import { Component } from "@angular/core";
import { ViewController, NavParams } from "ionic-angular";

@Component({
    selector: 'page-variables',
    templateUrl: 'variables.html'
})

export class VariablesPage {

    public variables_ocean: any = [];
    public variables_meteo: any = [];
    public selected_variable: any = '';
    public selected_curr_type: string = '';

    constructor(public navParams: NavParams, public viewCtrl: ViewController) {

        // let tmp_variables_ocean = this.navParams.data.variables_ocean;
        // console.log('data: ', this.navParams.data);
        this.navParams.data.variables_ocean.forEach((variable: any) => {
            this.variables_ocean.push(variable);
        });
        // console.log('this.variables_ocean: ', this.variables_ocean);

        this.navParams.data.variables_meteo.forEach((variable: any) => {
            this.variables_meteo.push(variable);
        });
        // console.log('this.variables_meteo: ', this.variables_meteo);

        this.selected_variable = this.navParams.data.selected
        this.selected_curr_type = this.navParams.data.selected_curr_type
        //console.log('variables: ', this.variables, this.selected_variable);
        
    }

    change_variable(variable1, variable2) {
        // console.log('Variables: ', variable1, variable2);
        this.selected_variable = variable1;
        this.selected_curr_type = variable2;
        this.close();
    }

    close() {
        this.viewCtrl.dismiss({
            selected_variable: this.selected_variable,
            selected_curr_type: this.selected_curr_type
        });
    }

}



// WEBPACK FOOTER //
// ./src/pages/variables/variables.ts